const StorageKeys = {
  ARTICLE_DATA: "wika_articleData",
  QUOTE_ID: "wika_quote_id"
};

export default StorageKeys;
